"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonTitle = exports.SkeletonPrice = exports.SkeletonImg = exports.SkeletonCard = exports.SkeletonBrand = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var animatedGradient = (0, _styledComponents.css)(["background:linear-gradient( -45deg,var(--color-global-grey400),var(--color-global-grey300),var(--color-global-grey400),var(--color-global-grey500) );background-size:400% 400%;animation:gradient 4s ease infinite;@keyframes gradient{0%{background-position:0% 50%;}50%{background-position:100% 50%;}100%{background-position:0% 50%;}}"]);
var SkeletonCard = exports.SkeletonCard = _styledComponents["default"].div.attrs({
  className: 'fuse-complex-product-card__skeleton',
  'data-testid': 'fuse-complex-product-card__skeleton'
}).withConfig({
  displayName: "styled-skeleton-card__SkeletonCard",
  componentId: "sc-l4ce6a-0"
})(["display:inline-flex;position:relative;flex-direction:column;width:100%;min-width:0;"]);
var SkeletonImg = exports.SkeletonImg = _styledComponents["default"].div.attrs({
  className: 'fuse-complex-product-card-skeleton__image',
  'data-testid': 'fuse-complex-product-card-skeleton__image'
}).withConfig({
  displayName: "styled-skeleton-card__SkeletonImg",
  componentId: "sc-l4ce6a-1"
})(["width:100%;aspect-ratio:3 /4;@supports not (aspect-ratio:3 / 4){padding-top:calc(4 / 3 * 100%);}margin:0 0 var(--spacing-global-space4);", ""], animatedGradient);
var SkeletonBrand = exports.SkeletonBrand = _styledComponents["default"].div.attrs({
  className: 'fuse-complex-product-card-skeleton__brand',
  'data-testid': 'fuse-complex-product-card-skeleton__brand'
}).withConfig({
  displayName: "styled-skeleton-card__SkeletonBrand",
  componentId: "sc-l4ce6a-2"
})(["width:78px;height:var(--font-line-height-m1);", " margin:0 0 var(--spacing-global-space2);"], animatedGradient);
var SkeletonTitle = exports.SkeletonTitle = _styledComponents["default"].div.attrs({
  className: 'fuse-complex-product-card-skeleton__title',
  'data-testid': 'fuse-complex-product-card-skeleton__title'
}).withConfig({
  displayName: "styled-skeleton-card__SkeletonTitle",
  componentId: "sc-l4ce6a-3"
})(["margin:0 0 var(--spacing-global-space2);&::before,&::after{content:'';display:block;height:var(--font-line-height-m1);", "}&:before{width:100%;margin:0 0 1px;}&:after{width:100%;}@media only screen and (min-width:", "){&:before{width:65%;}&:after{width:32%;}}"], animatedGradient, _grid.gridConfig.l.minWidth);
var SkeletonPrice = exports.SkeletonPrice = _styledComponents["default"].div.attrs({
  className: 'fuse-complex-product-card-skeleton__price',
  'data-testid': 'fuse-complex-product-card-skeleton__price'
}).withConfig({
  displayName: "styled-skeleton-card__SkeletonPrice",
  componentId: "sc-l4ce6a-4"
})(["height:24px;width:88px;", ""], animatedGradient);